export const FooterTemplate = {
    path: '/footer_templates',
    name: 'footer_templates',
    component: () => import('@/views/Edms/Template/FooterTemplatePage.vue'),
    children: [

        {
            path: '/footer_templates/add',
            name: 'footer_templates.add',
            component: () => import('@/views/Edms/Template/Form/FooterTemplateForm.vue'),
            props: { addAction: true }
        },
        {
            path: '/footer_templates/edit/:id',
            name: 'footer_templates.edit',
            component: () => import('@/views/Edms/Template/Form/FooterTemplateForm.vue'),
            props: { updateAction: true }
        },
        {
            path: '/footer_templates/delete/:id',
            name: 'footer_templates.delete',
            component: () => import('@/views/Edms/Template/Form/FooterTemplateForm.vue'),
            props: { deleteAction: true }
        },
        {
            path: '/footer_templates/view/:id',
            name: 'footer_templates.view',
            component: () => import('@/views/Edms/Template/Form/FooterTemplateForm.vue'),
            props: { viewAction: true }
        },
        {
            path: '/footer_templates/archive/:id',
            name: 'footer_templates.archive',
            component: () => import('@/views/Edms/Template/Form/FooterTemplateForm.vue'),
            props: { archiveAction: true }
        },
        {
            path: '/footer_templates/unarchive/:id',
            name: 'footer_templates.unarchive',
            component: () => import('@/views/Edms/Template/Form/FooterTemplateForm.vue'),
            props: { unarchiveAction: true }
        },
    ],
}
